export default __webpack_public_path__ + "static/media/white_background.6e0dca2a.JPG";